import React, { createContext, useContext, useState, useCallback } from "react";
import { translate } from "@/i18n";

const PrefsContext = createContext(null);

export function PrefsProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("mt_theme") || "light");
  const [lang, setLangState] = useState(() => localStorage.getItem("mt_lang") || "en");

  const setTheme = useCallback((t) => {
    localStorage.setItem("mt_theme", t);
    setThemeState(t);
  }, []);

  const setLang = useCallback((l) => {
    localStorage.setItem("mt_lang", l);
    setLangState(l);
  }, []);

  const t = useCallback((s) => translate(lang, s), [lang]);

  return (
    <PrefsContext.Provider value={{ theme, setTheme, lang, setLang, t }}>
      {children}
    </PrefsContext.Provider>
  );
}

export const useI18n = () => useContext(PrefsContext);
